const SPOTLIGHTS = [
  {
    title: '动作大片·燃爆暑期',
    desc: '热血沸腾的动作盛宴，硬汉对决、极限追车、枪林弹雨，暑期档最值得期待的动作电影全收录。从街头格斗到跨国追凶，每一帧都让你肾上腺素飙升。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20collage%20with%20explosions%20and%20car%20chases%20in%20urban%20cityscape%2C%20dramatic%20warm%20golden%20and%20fiery%20orange%20lighting%2C%20cinematic%20widescreen%20composition%2C%20intense%20atmosphere%2C%20movie%20poster%20style&width=900&height=500&seq=carousel-01&orientation=landscape',
    tag: '热门专题',
    accent: true,
  },
  {
    title: '爆笑喜剧·快乐一夏',
    desc: '没有什么是一部喜剧解决不了的！集结年度最搞笑的喜剧电影，从办公室闹剧到家庭乌龙，笑点密集不间断，陪你度过欢乐时光。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20comedic%20movie%20scene%20collage%20with%20funny%20expressions%20and%20colorful%20settings%2C%20warm%20sunny%20lighting%2C%20playful%20atmosphere%2C%20cinematic%20composition%20with%20vibrant%20colors&width=900&height=500&seq=carousel-02&orientation=landscape',
    tag: '笑料不断',
    accent: false,
  },
  {
    title: '科幻巨制·脑洞大开',
    desc: '穿越星际，探索未知。从时间悖论到人工智能觉醒，每一部科幻电影都是一次思想的冒险。震撼视觉效果配合深度叙事，打开想象力边界。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20science%20fiction%20movie%20collage%20with%20spaceships%20and%20alien%20landscapes%2C%20holographic%20interfaces%2C%20deep%20space%20nebula%20colors%2C%20cinematic%20widescreen%2C%20cool%20and%20warm%20light%20contrast&width=900&height=500&seq=carousel-03&orientation=landscape',
    tag: '视觉盛宴',
    accent: false,
  },
  {
    title: '国产新片·强势登场',
    desc: '国产电影近年来的惊艳之作全收录！从现实题材到奇幻冒险，中国电影人用镜头讲述属于我们的故事。剧情深度与制作水准全面突破。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20cinema%20movie%20collage%20with%20diverse%20urban%20and%20rural%20settings%2C%20dramatic%20lighting%2C%20emotional%20storytelling%20scenes%2C%20cinematic%20golden%20hour%20photography%2C%20rich%20warm%20earthy%20tones&width=900&height=500&seq=carousel-04&orientation=landscape',
    tag: '国产力作',
    accent: true,
  },
  {
    title: '港片经典·时光倒流',
    desc: '那些年我们一起追过的香港电影回来了！从警匪对决到江湖情义，从无厘头喜剧到文艺经典，89部修复版港片带你重温黄金年代的光影记忆。',
    img: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20movie%20collage%20with%20neon%20signs%20and%20rainy%20streets%2C%20nostalgic%20film%20grain%20texture%2C%20vintage%20cinematic%20colors%2C%20warm%20amber%20and%20teal%20tones%2C%20retro%20movie%20poster%20aesthetic&width=900&height=500&seq=carousel-05&orientation=landscape',
    tag: '经典回顾',
    accent: false,
  },
  {
    title: '悬疑烧脑·智商挑战',
    desc: '准备好被反转震撼了吗？精选全球高分悬疑电影，每一部都有让人意想不到的结局。连环陷阱、不可靠叙述者、平行时空，挑战你的推理极限。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20thriller%20movie%20collage%20with%20dark%20shadows%20and%20dramatic%20lighting%2C%20detective%20elements%2C%20foggy%20atmosphere%2C%20noir%20cinematography%2C%20high%20contrast%20black%20and%20warm%20tones%2C%20suspenseful%20composition&width=900&height=500&seq=carousel-06&orientation=landscape',
    tag: '烧脑推荐',
    accent: false,
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">精选主题策划，发现更多好电影</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SPOTLIGHTS.map((item) => (
            <a
              key={item.title}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-100 border border-background-200/60 rounded-lg overflow-hidden hover:border-primary-500/40 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={`97影视 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent pointer-events-none" />
                <div className="absolute top-3 left-3">
                  <span className={`px-2 py-0.5 text-[10px] font-medium rounded ${
                    item.accent
                      ? 'bg-accent-500/90 text-background-50'
                      : 'bg-primary-500/90 text-background-50'
                  }`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}